import { lazy } from 'react';

const ManufactureRecordsAdminConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/adm/consult/manufacture-records',
			component: lazy(() => import('./ManufactureRecordsContainer'))
		}
	]
};

export default ManufactureRecordsAdminConfig;
